// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

import './jquery-global.js';
import './jquery-ui.min.js';
import fullpage from 'fullpage.js';

import Header from '../_modules/header/header';
import Hero from '../_modules/hero/hero';

$(() => {
  //console.log('Welcome to Yeogurt!');
  
  window.onscroll = function (e) {
    // called when the window is scrolled. 

    if ($(window).scrollTop() >= 50) {
      $('body').addClass('hasScrolled');
    } else {
      $('body').removeClass('hasScrolled');

    }
  }

  new Header();

  new fullpage('#fullpage', {
    //options here
    autoScrolling: true,
    scrollHorizontally: false,
    responsiveHeight: 600,
    responsiveWidth: 768,
    anchors: ['ProsperityProject', 'brand', 'persone', 'contatti'],
    onLeave: function (origin, destination, direction) {
      var loadedSection = this;

      //using index
      console.log(destination.index);
      if (destination.index > 0) {
        $('body').addClass('hasScrolled');
        $('.pageHeader__navigationItem').removeClass('current-menu-item').eq(destination.index-1).addClass('current-menu-item');
      }
      else {
        $('.pageHeader__navigationItem').removeClass('current-menu-item');
        $('body').removeClass('hasScrolled');
      }

      
    }
  });
});
